﻿<script setup>
import BaseIconButton from '@/components/shared/ui/BaseIconButton.vue'
import { useAuthStore } from '@/pinia/auth'
const authStore = useAuthStore()
</script>

<template>
  <div v-if="!authStore.isCookiePopUpHidden" class="fixed bottom-0 right-0 !z-50 p-10 w-full pointer-events-none">
    <div
      class="relative flex gap-5 bg-white rounded drop-shadow-md p-5 xs:p-10 max-w-[600px] mx-auto pointer-events-auto"
    >
      <div class="flex flex-col gap-2">
        <h2 class="font-medium">{{ $t('common.global.cookieTitle') }}</h2>
        <span>{{ $t('common.global.cookieText') }}</span>
      </div>
      <BaseIconButton
        icon="cancel"
        size="lg"
        class="ml-auto self-start"
        @click="authStore.isCookiePopUpHidden = true"
      />
    </div>
  </div>
</template>
